import { useState, useEffect, useCallback } from 'react';
import api from '../../api';

const STATUS_LABELS = {
  listed:     { label: "E'lon joylangan", color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  onboarding: { label: 'Jarayonda',       color: '#60a5fa', bg: 'rgba(96,165,250,0.12)' },
  active:     { label: "To'liq o'rnatilgan", color: '#4ade80', bg: 'rgba(74,222,128,0.12)' },
  churned:    { label: 'Tark etgan',      color: '#f87171', bg: 'rgba(248,113,113,0.12)' },
};

const CITIES = ['Toshkent', 'Samarqand', 'Buxoro', 'Namangan', 'Andijon', 'Farg\'ona', 'Nukus', 'Qo\'qon', 'Qarshi', 'Termiz'];

const EMPTY_FORM = {
  name: '', city: '', address: '', phone: '', lat: '', lng: '',
  pc_count: '', working_hours: '', instagram: '', telegram: '', cover_url: '', source: 'manual',
};

export default function SuperClubs() {
  const [tab, setTab]           = useState('listed');
  const [clubs, setClubs]       = useState([]);
  const [total, setTotal]       = useState(0);
  const [loading, setLoading]   = useState(true);
  const [q, setQ]               = useState('');
  const [city, setCity]         = useState('');
  const [modal, setModal]       = useState(null); // null | 'add' | {id,...} edit
  const [form, setForm]         = useState(EMPTY_FORM);
  const [saving, setSaving]     = useState(false);
  const [deleting, setDeleting] = useState(null);

  const load = useCallback((statusFilter = tab) => {
    setLoading(true);
    const params = new URLSearchParams({ status: statusFilter, limit: 100 });
    if (q) params.set('q', q);
    if (city) params.set('city', city);
    api.get(`/super/clubs?${params}`)
      .then(r => { setClubs(r.data.clubs || []); setTotal(r.data.total || 0); })
      .finally(() => setLoading(false));
  }, [tab, q, city]);

  useEffect(() => { load(); }, [load]);

  const switchTab = (t) => { setTab(t); setQ(''); setCity(''); };

  const openAdd = () => { setForm(EMPTY_FORM); setModal('add'); };
  const openEdit = (c) => {
    setForm({
      name: c.name || '', city: c.city || '', address: c.address || '',
      phone: c.phone || '', lat: c.lat || '', lng: c.lng || '',
      pc_count: c.pc_count || '', working_hours: c.working_hours || '',
      instagram: c.instagram || '', telegram: c.telegram || '',
      cover_url: c.cover_url || '', source: c.source || 'manual',
    });
    setModal(c);
  };

  const save = async () => {
    if (!form.name || !form.address) return alert('Nomi va manzil majburiy');
    setSaving(true);
    try {
      if (modal === 'add') {
        const r = await api.post('/super/clubs', form);
        setClubs(prev => [r.data, ...prev]);
        setTotal(t => t + 1);
      } else {
        const r = await api.put(`/super/clubs/${modal.id}`, form);
        setClubs(prev => prev.map(c => c.id === modal.id ? { ...c, ...r.data, ...form } : c));
      }
      setModal(null);
    } catch (e) {
      alert(e.response?.data?.error || 'Xatolik');
    } finally { setSaving(false); }
  };

  const changeStatus = async (id, status) => {
    try {
      await api.patch(`/super/clubs/${id}/status`, { status });
      if (status === 'active' || tab !== status) {
        setClubs(prev => prev.filter(c => c.id !== id));
        setTotal(t => t - 1);
      } else {
        setClubs(prev => prev.map(c => c.id === id ? { ...c, status } : c));
      }
    } catch (e) { alert(e.response?.data?.error || 'Xatolik'); }
  };

  const deleteClub = async (id) => {
    if (!window.confirm('Haqiqatan o\'chirib tashlamoqchimisiz?')) return;
    setDeleting(id);
    try {
      await api.delete(`/super/clubs/${id}`);
      setClubs(prev => prev.filter(c => c.id !== id));
      setTotal(t => t - 1);
    } catch (e) { alert(e.response?.data?.error || 'Xatolik'); }
    finally { setDeleting(null); }
  };

  const tabData = {
    listed:     { label: "E'lon joylangan", desc: '2GIS / qo\'lda topilgan klublar', color: '#f59e0b' },
    active:     { label: "To'liq o'rnatilgan", desc: 'Defuse platformasida ishlayotganlar', color: '#4ade80' },
  };

  return (
    <div style={{ padding: 24 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>🏢 Klublar katalogi</h2>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>O'zbekistondagi gaming klublar ro'yxati</div>
        </div>
        <button onClick={openAdd} style={{
          padding: '9px 18px', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 700,
          background: 'rgba(0,212,255,0.12)', border: '1px solid var(--cyan)', color: 'var(--cyan)',
        }}>+ Klub qo'shish</button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 16, borderBottom: '1px solid var(--border)', paddingBottom: 0 }}>
        {Object.entries(tabData).map(([key, info]) => (
          <button key={key} onClick={() => switchTab(key)} style={{
            padding: '10px 20px', borderRadius: '8px 8px 0 0', fontSize: 13, cursor: 'pointer', fontWeight: 700,
            background: tab === key ? 'var(--card)' : 'transparent',
            border: tab === key ? `1px solid var(--border)` : '1px solid transparent',
            borderBottom: tab === key ? '1px solid var(--card)' : 'none',
            color: tab === key ? info.color : 'var(--text3)',
            marginBottom: tab === key ? -1 : 0,
          }}>
            {info.label}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <input value={q} onChange={e => setQ(e.target.value)}
          placeholder="🔍 Nomi, manzil, telefon..."
          style={{ flex: 1, minWidth: 200, maxWidth: 300, padding: '8px 12px', borderRadius: 8,
            fontSize: 13, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)' }} />
        <select value={city} onChange={e => setCity(e.target.value)} style={{
          padding: '8px 12px', borderRadius: 8, fontSize: 13,
          background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)',
        }}>
          <option value="">Barcha shaharlar</option>
          {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <div style={{ padding: '8px 14px', borderRadius: 8, background: 'rgba(0,212,255,0.08)',
          border: '1px solid var(--border)', fontSize: 13, color: 'var(--text3)' }}>
          Jami: <b style={{ color: 'var(--text)' }}>{total}</b>
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div style={{ color: 'var(--text3)', padding: 40, textAlign: 'center' }}>Yuklanmoqda...</div>
      ) : clubs.length === 0 ? (
        <div style={{ color: 'var(--text3)', padding: 40, textAlign: 'center' }}>
          {tab === 'listed' ? (
            <>
              <div style={{ fontSize: 32, marginBottom: 12 }}>🗺️</div>
              <div style={{ fontWeight: 700, marginBottom: 8 }}>Hali klub qo'shilmagan</div>
              <div style={{ fontSize: 12 }}>2GIS yoki qo'lda club qo'shing</div>
            </>
          ) : (
            <>
              <div style={{ fontSize: 32, marginBottom: 12 }}>🏢</div>
              <div style={{ fontWeight: 700 }}>To'liq o'rnatilgan klub yo'q</div>
            </>
          )}
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)', color: 'var(--text3)', fontSize: 11 }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>#</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Klub nomi</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Shahar</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Manzil</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Telefon</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>PC</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Status</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600 }}>Manba</th>
                <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600 }}>Amallar</th>
              </tr>
            </thead>
            <tbody>
              {clubs.map((c, i) => {
                const st = STATUS_LABELS[c.status] || STATUS_LABELS.listed;
                return (
                  <tr key={c.id} style={{ borderBottom: '1px solid var(--border)', transition: 'background 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.03)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 12px', color: 'var(--text3)' }}>{i + 1}</td>
                    <td style={{ padding: '10px 12px', fontWeight: 600, maxWidth: 180 }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.name}</div>
                      {c.owner_name && <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2 }}>👤 {c.owner_name}</div>}
                    </td>
                    <td style={{ padding: '10px 12px', color: 'var(--text2)' }}>{c.city || '—'}</td>
                    <td style={{ padding: '10px 12px', color: 'var(--text2)', maxWidth: 200 }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={c.address}>{c.address}</div>
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      {c.phone ? (
                        <a href={`tel:${c.phone}`} style={{ color: 'var(--cyan)', textDecoration: 'none' }}>{c.phone}</a>
                      ) : <span style={{ color: 'var(--text3)' }}>—</span>}
                    </td>
                    <td style={{ padding: '10px 12px', color: 'var(--text2)' }}>{c.pc_count || '—'}</td>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{ padding: '3px 8px', borderRadius: 5, fontSize: 11, fontWeight: 700,
                        background: st.bg, color: st.color }}>{st.label}</span>
                    </td>
                    <td style={{ padding: '10px 12px', color: 'var(--text3)', fontSize: 11 }}>
                      {c.source === '2gis' ? '2GIS' : c.source === 'google' ? 'Google' : c.source === 'manual' ? 'Qo\'lda' : c.source || '—'}
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                        {c.status === 'listed' && (
                          <button onClick={() => changeStatus(c.id, 'onboarding')} style={{
                            padding: '4px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer', fontWeight: 600,
                            background: 'rgba(96,165,250,0.1)', border: '1px solid #60a5fa', color: '#60a5fa',
                          }}>📞 Murojaat</button>
                        )}
                        {c.status === 'onboarding' && (
                          <button onClick={() => changeStatus(c.id, 'active')} style={{
                            padding: '4px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer', fontWeight: 600,
                            background: 'rgba(74,222,128,0.1)', border: '1px solid #4ade80', color: '#4ade80',
                          }}>✅ Faollashtir</button>
                        )}
                        <button onClick={() => openEdit(c)} style={{
                          padding: '4px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer',
                          background: 'rgba(0,212,255,0.08)', border: '1px solid var(--cyan)', color: 'var(--cyan)',
                        }}>✏️</button>
                        {c.status !== 'active' && (
                          <button onClick={() => deleteClub(c.id)} disabled={deleting === c.id} style={{
                            padding: '4px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer',
                            background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.5)', color: '#f87171',
                            opacity: deleting === c.id ? 0.5 : 1,
                          }}>🗑️</button>
                        )}
                        {c.lat && c.lng && (
                          <a href={`https://maps.google.com/?q=${c.lat},${c.lng}`} target="_blank" rel="noreferrer"
                            style={{ padding: '4px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer',
                              background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.4)', color: '#4ade80',
                              textDecoration: 'none' }}>🗺️</a>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Add/Edit Modal */}
      {modal && (
        <div onClick={() => setModal(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: 'var(--card)', border: '1px solid var(--border)',
            borderRadius: 16, padding: 24, width: 540, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ margin: 0, fontSize: 15 }}>{modal === 'add' ? '+ Yangi klub' : '✏️ Tahrirlash'}</h3>
              <button onClick={() => setModal(null)} style={{ background: 'transparent', border: 'none', color: 'var(--text2)', fontSize: 20, cursor: 'pointer' }}>✕</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {[
                ['Klub nomi *', 'name', false],
                ['Shahar', 'city', false],
                ['Telefon', 'phone', false],
                ['PC soni', 'pc_count', false],
                ['Ish vaqti', 'working_hours', false],
                ['Instagram', 'instagram', false],
                ['Telegram', 'telegram', false],
                ['Cover URL', 'cover_url', false],
              ].map(([label, key]) => (
                <div key={key}>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 3 }}>{label}</div>
                  <input value={form[key] || ''} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                    style={{ width: '100%', padding: '7px 10px', borderRadius: 7, fontSize: 12, boxSizing: 'border-box',
                      background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)' }} />
                </div>
              ))}
            </div>

            <div style={{ marginTop: 10 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 3 }}>Manzil *</div>
              <input value={form.address || ''} onChange={e => setForm(f => ({ ...f, address: e.target.value }))}
                style={{ width: '100%', padding: '7px 10px', borderRadius: 7, fontSize: 12, boxSizing: 'border-box',
                  background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)' }} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 10 }}>
              {[['Lat (kenglik)', 'lat'], ['Lng (uzunlik)', 'lng']].map(([label, key]) => (
                <div key={key}>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 3 }}>{label}</div>
                  <input value={form[key] || ''} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                    placeholder="41.2995" style={{ width: '100%', padding: '7px 10px', borderRadius: 7, fontSize: 12,
                      boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)' }} />
                </div>
              ))}
            </div>

            <div style={{ marginTop: 10 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 3 }}>Manba</div>
              <select value={form.source || 'manual'} onChange={e => setForm(f => ({ ...f, source: e.target.value }))}
                style={{ width: '100%', padding: '7px 10px', borderRadius: 7, fontSize: 12,
                  background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)' }}>
                <option value="manual">Qo'lda</option>
                <option value="2gis">2GIS</option>
                <option value="google">Google Maps</option>
                <option value="instagram">Instagram</option>
                <option value="telegram">Telegram</option>
              </select>
            </div>

            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button onClick={() => setModal(null)} style={{ flex: 1, padding: 10, borderRadius: 8, fontSize: 13,
                cursor: 'pointer', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)' }}>Bekor</button>
              <button onClick={save} disabled={saving} style={{ flex: 2, padding: 10, borderRadius: 8, fontSize: 13,
                cursor: 'pointer', fontWeight: 700, opacity: saving ? 0.6 : 1,
                background: 'rgba(0,212,255,0.12)', border: '1px solid var(--cyan)', color: 'var(--cyan)' }}>
                {saving ? 'Saqlanmoqda...' : '💾 Saqlash'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
